'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

import { useLogin } from "@/lib/api/hooks/auth" // ✅ wrapper hook
import { parseApiError } from "@/lib/api/utils/errors"

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { toast } from "sonner"

const fieldLabel = 'block text-[0.7rem] tracking-[0.22em] text-[#1a1a1a]/55 uppercase'
const fieldInput =
  'h-11 rounded-none border-0 border-b border-[#1a1a1a]/20 bg-transparent px-0 text-[#1a1a1a] ' +
  'shadow-none placeholder:text-[#1a1a1a]/30 focus-visible:border-[#c9a96e] focus-visible:ring-0'

export default function SignInForm() {
  const router = useRouter()
  const { login, isPending } = useLogin()

  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()

    setError(null)

    try {
      await login({
        identifier,
        password
      })

      // ✅ refresh server components (important with SSR)
      router.refresh()

      // ✅ navigate cleanly
      router.push('/dashboard')

    } catch (err: any) {
      setError(parseApiError(err))
      toast.error("Échec de la connexion", {
        description: parseApiError(err)
      })
    }
  }

  return (
    <form onSubmit={handleSubmit} className='w-full space-y-6'>

      <div className='space-y-2'>
        <label htmlFor='identifier' className={fieldLabel}>
          Email ou identifiant
        </label>
        <Input
          id='identifier'
          type='text'
          placeholder='vous@dorahart.com'
          autoComplete='username'
          value={identifier}
          onChange={(e)=>setIdentifier(e.target.value)}
          className={fieldInput}
          required
        />
      </div>

      <div className='space-y-2'>
        <label htmlFor='password' className={fieldLabel}>
          Mot de passe
        </label>
        <Input
          id='password'
          type='password'
          placeholder='••••••••'
          autoComplete='current-password'
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
          className={fieldInput}
          required
        />
      </div>

      {error && (
        <div className='rounded-none border-l-2 border-[#c9a96e] bg-[#c9a96e]/10 px-3 py-2 text-sm text-[#1a1a1a]/80'>
          {error}
        </div>
      )}

      <Button
        disabled={isPending}
        className='h-12 w-full rounded-none bg-[#1a1a1a] text-[0.72rem] tracking-[0.22em] text-[#fffdfa] uppercase transition-colors hover:bg-[#c9a96e] hover:text-[#1a1a1a] disabled:opacity-60'
      >
        {isPending ? 'Connexion…' : 'Se connecter'}
      </Button>

    </form>
  )
}
